<template>
   <div class="list dataset-list">
      <div v-if="cloud_datasets.length == 0 && data_ready">No Datasets</div>
      <div class="list-data" v-for="(dataset, index) in filtered_datasets" :key="index">
         <div class="data">
         <div class="columns-wrapper">
         <div class="tabular-content column-left">
            <div class="dataset-header clearfix">
            <div class="dataset-field title-badge">
            <div class="dataset-field name"><span v-if="dataset_url(dataset)"><a :href="dataset_url(dataset)" target="_blank">{{dataset['umm']['EntryTitle']}}</a></span><span v-else>{{dataset['umm']['EntityTitle']}}</span><span v-if="dataset['umm']['ShortName']"><br/>({{dataset['umm']['ShortName']}})</span></div>
            <div class="dataset-field science-keywords">
               <ul>
                  <!--
                  <li v-for="(keyword, keywordIndex) in dataset_unique_science_keywords(dataset['umm']['ScienceKeywords'])" :key="'keyword'+keywordIndex" class="eui-badge--md" v-on:click="show_science_keyword_datasets_modal({'keyword':keyword,'scienceKeywords':get_measurement_by_keyword(keyword,dataset['umm']['ScienceKeywords'])})">
                     {{keyword}}
                  </li>
                  -->
                  <li v-for="(keyword, keywordIndex) in dataset_unique_science_keywords(dataset['umm']['ScienceKeywords'])" :key="'keyword'+keywordIndex" class="eui-badge--md" v-on:click="show_science_keyword_datasets_modal(keyword, get_measurement_by_keyword(keyword,dataset['umm']['ScienceKeywords']))">
                     {{keyword}}
                  </li>
               </ul>
            </div>
            </div>
            </div>
            <ul class="content-tabs">
               <li :class="tabSelector(dataset, ['pi', 'pi-info-circle'],'info')" v-on:click="toggleTabContent(dataset,'info');"><span class="label">Information</span></li>
               <li :class="tabSelector(dataset, ['pi', 'pi-globe'],'coverage')" v-on:click="toggleTabContent(dataset,'coverage'); load_coverage_content(dataset)"><span class="label">Coverage</span></li>
               <li :class="tabSelector(dataset, ['fa', 'fa-database'],'access')" v-on:click="toggleTabContent(dataset,'access');"><span class="label">Data Access</span></li>
               <li :class="tabSelector(dataset, ['pi', 'pi-file'],'doc')" v-on:click="toggleTabContent(dataset,'doc');"><span class="label">Documentation</span></li>
               <li :class="tabSelector(dataset, ['pi', 'pi-bookmark'],'citation')" v-on:click="toggleTabContent(dataset,'citation');"><span class="label">Citation</span></li>
            </ul>
            <div id="info" v-if="dataset.showtab == undefined || dataset.showtab == '' || dataset.showtab == 'info'">
               <!--<div class="info-content-wrapper">
               <div class="column-left">-->
               <div class="metadata">
               <div class="dataset-field fieldset version">
                  <span class="label-arrow-tag">Version:</span>
                  <span class="field-content" v-html="datasetFieldValue(dataset,['Version'])" />
               </div>
               <div class="dataset-field fieldset processing-level">
                  <span class="label-arrow-tag">Processing Level:</span>
                  <span class="field-content" v-html="dataset['umm']['ProcessingLevel']['Id']" />
               </div>
               <div class="dataset-field fieldset start-stop">
                  <span class="label-arrow-tag">Start/Stop Date:</span>
                  <span class="field-content" v-html="dataset_start_stop_time(dataset['umm']['TemporalExtents'])" />
               </div>
               <div class="dataset-field fieldset description-excerpt">
                  <div class="label-arrow-tag">Description:</div>
                  <div class="field-content" :class="toggle_description_wrapper_classes(dataset)" :set="excerpt=truncateDescriptionText(dataset['umm']['Abstract'],100)">
                     <!--<truncate clamp="...more" :length="200" less="show less" :text="dataset['umm']['Abstract']"></truncate>-->
                     <span v-if="!dataset['show_detail']"><span v-html="excerpt['default']"></span><span v-if="excerpt['clamp']">{{excerpt['clamp']}}</span></span>
                     <span v-if="dataset['show_detail']"><span v-html="dataset['umm']['Abstract']"></span></span>
                     <span v-if="!dataset['show_detail']" class="info-detail-more-wrapper"><button type="button" class="content-toggle" v-on:click="toggle_dataset_detail(dataset)">{{dataset_detail_more_button(dataset)}}</button></span>
                  </div>
               </div>
               <div :class="info_detail_wrapper_classes(dataset['show_detail'])">
               <div class="info-detail" v-if="dataset['show_detail']">
               <!--   <summary>Detail Information</summary>-->
               <!-- <div class="dataset-field fieldset description">
                  <div class="label-arrow-tag">Description:</div>
                  <div class="field-content" :class="toggle_description_wrapper_classes(dataset)">
                     {{dataset['umm']['Abstract']}}
                  </div>
               </div> -->
               <div class="dataset-field fieldset doi" v-if="dataset['umm']['DOI'] != undefined && dataset['umm']['DOI']['DOI'] != undefined">
                  <span class="label-arrow-tag">DOI:</span>
                  <span class="field-content">
                     <a :href="'https://doi.org/'+dataset['umm']['DOI']['DOI']" target="_blank">{{dataset['umm']['DOI']['DOI']}}</a>
                  </span>
               </div>
               <div class="dataset-field fieldset measurement" v-if="datasetFieldValue(dataset,['ScienceKeywords']) != undefined" style="display:flex">
                  <span class="label-arrow-tag">Measurement:</span>
                  <span class="field-content" v-html="dataset_measurements(dataset['umm']['ScienceKeywords'])"></span>
               </div>
               <!--               
               <div class="dataset-field fieldset projection" v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem']) != undefined">
                  <div v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','HorizontalDataResolution','GenericResolutions']) != undefined"  :set="resolutionData = datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','HorizontalDataResolution','GenericResolutions'])">
                     <span class="label-arrow-tag">Spatial Resolution:</span>
                     <span class="field-content" v-if="resolutionData != undefined && ['1','2'].includes(datasetFieldValue(dataset,['ProcessingLevel','Id']))">
                        <span v-if="resolutionData['ydimension'] != undefined && resolutionData['xdimension'] != undefined">{{Math.round(resolutionData['ydimension']/1000).toFixed(2)}} km (Along) x {{Math.round(resolutionData['xdimension']/1000).toFixed(2)}} km (Across)</span>
                     </span>
                     <span class="field-content" v-else>
                        <span v-if="resolutionData[0]['ydimension'] != undefined && resolutionData[0]['xdimension'] != undefined">{{resolutionData[0]['ydimension']}} degrees (Latitude) x {{resolutionData[0]['xdimension']}} degrees (Longitude)</span>
                     </span>
                  </div>
                  <div class="field-content temporal" v-if="datasetFieldValue(dataset,['TemporalKeywords']) != undefined && datasetFieldValue(dataset,['TemporalKeywords'])[0] != undefined">
                     <span class="label-arrow-tag">Temporal Resolution:</span>
                     <span class="field-content">{{datasetFieldValue(dataset,['TemporalKeywords'])[0]}}</span>
                  </div>
               </div>
               <div class="dataset-field fieldset swath-width" v-if="datasetFieldValue(dataset,['SpatialExtent','OrbitParameters','SwathWidth']) != undefined">
                  <span class="label-arrow-tag">Swath Width:</span>
                  <span v-html="datasetFieldValue(dataset,['SpatialExtent','OrbitParameters','SwathWidth']) + ' km'" />
               </div>
               -->
                  <!--<div class="field-content projection-info">
                     <div v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','Description']) != undefined" :set="projectData = datasetProjectionData(datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','Description']))">
                        <span class="label-arrow-tag">Projection:</span>
                        <span class="field-content" v-for="(projectiontext, dataIndex) in projectData" :key="dataIndex">
                          {{projectiontext}}
                        </span>
                     </div>

                     <div v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','GeodeticModel','EllipsoidName']) != undefined">
                        <span class="label-arrow-tag">Ellipsoid:</span>
                        <span>{{datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','GeodeticModel','EllipsoidName'])}}</span>
                     </div>
                  </div>-->               
               <div class="dataset-field fieldset projects" v-if="dataset['umm']['Projects'] != undefined && dataset['umm']['Projects'].length > 0">
                  <span class="label-arrow-tag">Projects:</span>
                  <span class="field-content projects-info" :set="projects = dataset['umm']['Projects']">
                     <span v-for="(project, projectIndex) in projects" :key="projectIndex">
                        {{project["LongName"]}} ({{project["ShortName"]}})
                     </span>
                  </span>
               </div>
               <div class="dataset-field fieldset data-provider" v-if="dataset['umm']['CollectionCitations'] != undefined">
                  <div style="display:flex">
                  <div class="label-arrow-tag">Data Provider:</div>
                  <div class="field-content data-provider-info">
                     <div v-if="dataset['umm']['CollectionCitations'][0]['Publisher'] != undefined">
                        <span class="sub-label">Publisher:</span> <span>{{dataset['umm']['CollectionCitations'][0]['Publisher']}}</span>
                     </div>
                     <div v-if="dataset['umm']['CollectionCitations'][0]['Creator'] != undefined">
                        <span class="sub-label">Creator:</span> <span>{{dataset['umm']['CollectionCitations'][0]['Creator']}}</span>
                     </div>
                     <div v-if="dataset['umm']['CollectionCitations'][0]['ReleasePlace'] != undefined">
                        <span class="sub-label">Release Place:</span> <span>{{dataset['umm']['CollectionCitations'][0]['ReleasePlace']}}</span>
                     </div>
                     <div v-if="dataset['umm']['CollectionCitations'][0]['ReleaseDate'] != undefined">
                        <span class="sub-label">Release Date:</span> <span>{{dataset_datetime_value(dataset['umm']['CollectionCitations'][0]['ReleaseDate'])}}</span>
                     </div>
                  </div>
                  </div>
               </div>
               <div class="dataset-field fieldset format" 
                  v-if="dataset['umm']['ArchiveAndDistributionInformation'] != undefined   
                     && dataset['umm']['ArchiveAndDistributionInformation']['FileDistributionInformation'] != undefined">
                  <span class="label-arrow-tag">Format:</span>
                  <span class="field-content">{{dataset["umm"]['ArchiveAndDistributionInformation']['FileDistributionInformation'][0]['Format']}}</span>
               </div>
               <div class="dataset-field fieldset keywords" v-if="datasetFieldValue(dataset,['AncillaryKeywords']) != undefined">
                  <span class="label-arrow-tag">Keyword(s):</span>
                  <span class="field-content" v-html="datasetFieldValue(dataset,['AncillaryKeywords']).join(', ')" />
               </div>
               </div> <!--/info-detail-->
               <div class="info-detail-more-wrapper" v-if="dataset['show_detail']"><button type="button" class="content-toggle" v-on:click="toggle_dataset_detail(dataset)">{{dataset_detail_more_button(dataset)}}</button></div>
               </div> <!--/info-detail-wrapper-->
               <!--</div>--> <!-- /column-left -->
               <!--<div class="column-right">
                  <div class="dataset-field fieldset dataset-status">
                     <label class="arrow-tag">Status:</label>
                     <span :class="progress_badge_icon(dataset['umm']['CollectionProgress'])" v-html="dataset['umm']['CollectionProgress']" />
                  </div>
                  <div class="dataset-field fieldset services">
                     <label>Services</label>
                     <ul class="icons">
                        <li v-for="(service, index) in dataset['umm']['data_access']" :key="index">{{service}}</li>
                     </ul>
                  </div>
               </div>
               </div> --> <!-- /info-content-wrapper -->
               </div> <!-- metadata -->
            </div>
            <div id="coverage" v-if="dataset.showtab == 'coverage'">
               <div class="dataset-field spatial">
                  <div class="content-wrapper">
                     <div class="label label-arrow-tag">Resolution:</div>
                     <div class="field-content-section-wrapper">
                     <div class="dataset-field fieldset resolution" v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem']) != undefined">                        
                        <div v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','HorizontalDataResolution','GenericResolutions']) != undefined"  :set="resolutionData = datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','HorizontalDataResolution','GenericResolutions'])">
                           <span class="label-arrow-tag">Spatial Resolution:</span>
                           <span class="field-content">
                              <span v-if="resolutionData[0]['ydimension'] != undefined && resolutionData[0]['xdimension'] != undefined">{{resolutionData[0]['ydimension']}} {{resolutionData[0]['unit']}} x {{resolutionData[0]['xdimension']}} {{resolutionData[0]['unit']}}</span>
                           </span>
                        </div>
                        <div class="field-content temporal" v-if="datasetFieldValue(dataset,['TemporalKeywords']) != undefined && datasetFieldValue(dataset,['TemporalKeywords'])[0] != undefined">
                           <span class="label-arrow-tag">Temporal Resolution:</span>
                           <span class="field-content">{{datasetFieldValue(dataset,['TemporalKeywords'])[0]}}</span>
                        </div>
                     </div>
                     </div>            
                     <div class="label label-arrow-tag">Coverage:</div>
                     <div class="field-content-section-wrapper">
                     <div class="field-content region" v-if="datasetFieldValue(dataset,['LocationKeywords']) != undefined">
                        <div v-for="(region, dataIndex) in datasetFieldValue(dataset,['LocationKeywords'])" :key="dataIndex">
                           <span v-if="region['type'] != undefined"><strong>Region:</strong> {{region['type']}}</span>
                        </div>
                     </div>
                     <div v-if="dataset_coverage_bound(datasetFieldValue(dataset,['SpatialExtent'])).length > 1">
                        <div class="field-content coverage-text" v-for="(coverage_bound, index) in dataset_coverage_bound(datasetFieldValue(dataset,['SpatialExtent']))" :key="index">
                        <div>
                           <span class="label">North </span> <span>{{coverage_bound['N']}}&#176;&nbsp;</span>
                           <span class="label">South </span> <span>{{coverage_bound['S']}}&#176;&nbsp;</span>
                           <span class="label">West </span> <span>{{coverage_bound['W']}}&#176;&nbsp;</span>
                           <span class="label">East </span> <span>{{coverage_bound['E']}}&#176;&nbsp;</span>
                        </div>                        
                        </div>
                     </div>
                     <div v-else>
                     <div class="field-content coverage-text" v-for="(coverage_bound, idx) in dataset_coverage_bound(datasetFieldValue(dataset,['SpatialExtent']))" :key="idx">
                        <div><span class="label">North Bounding Coordinate:</span> <span>{{coverage_bound['N']}}&#176;</span></div>
                        <div><span class="label">South Bounding Coordinate:</span> <span>{{coverage_bound['S']}}&#176;</span></div>
                        <div><span class="label">West Bounding Coordinate:</span> <span>{{coverage_bound['W']}}&#176;</span></div>
                        <div><span class="label">East Bounding Coordinate:</span> <span>{{coverage_bound['E']}}&#176;</span></div>
                     </div>
                     </div>
                     <div v-if="dataset_coverage_bounding_points(datasetFieldValue(dataset,['SpatialExtent'])).length > 0">
                        <div class="field-content coverage-text" v-for="(coverage_bound, index) in dataset_coverage_bounding_points(datasetFieldValue(dataset,['SpatialExtent']))" :key="index">
                           <div><span class="label">Longitude:</span> <span>{{coverage_bound[0]}}&#176;</span></div>
                           <div><span class="label">Latitude:</span> <span>{{coverage_bound[1]}}&#176;</span></div>
                        </div>
                     </div>
                     <div class="field-content coverage-text">
                        <div><span class="label">Time Span:</span> {{dataset_temporal_output(datasetFieldValue(dataset,['TemporalExtents']), 'start')}} to {{dataset_temporal_output(datasetFieldValue(dataset,['TemporalExtents']), 'end')}}</div>
                        <div v-if="dataset['umm']['AdditionalAttributes'] != undefined" :set="granule_time_span=datset_granule_time_span(datasetFieldValue(dataset,['AdditionalAttributes']))"><div v-if="granule_time_span"><span class="label">Granule Time Span:</span> {{datset_granule_time_span(datasetFieldValue(dataset,['AdditionalAttributes']))}}</div></div>
                     </div>
                     <div class="field-content swath-width" v-if="datasetFieldValue(dataset,['SpatialExtent','OrbitParameters','SwathWidth']) != undefined">
                        <span class="label-arrow-tag">Swath Width:</span>
                        <span v-html="datasetFieldValue(dataset,['SpatialExtent','OrbitParameters','SwathWidth']) + ' km'" />
                     </div>
                     </div>
                     <div class="field-content-section-wrapper" v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','Description']) != undefined || datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','GeodeticModel','EllipsoidName']) != undefined">
                     <div class="label label-arrow-tag">Projection:</div>
                     <div class="field-content">
                        <div v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','Description']) != undefined" :set="projectData = datasetProjectionData(datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','Description']))">
                           <div class="field-content" v-for="(projectiontext, dataIndex) in projectData" :key="dataIndex">
                              <div v-if="projectiontext !=''">
                                 <strong>{{dataIndex}}:</strong> {{projectiontext}}
                              </div>
                              <div v-else>{{dataIndex}}</div>
                           </div>
                        </div>
                        <div v-if="datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','GeodeticModel','EllipsoidName']) != undefined">
                           <span class="label-arrow-tag">Ellipsoid:</span>
                           <span>{{datasetFieldValue(dataset,['SpatialExtent','HorizontalSpatialDomain','ResolutionAndCoordinateSystem','GeodeticModel','EllipsoidName'])}}</span>
                        </div>
                     </div>  
                     </div>                   
                  </div>
                  <div class="field-content">
                     <l-map
                        :zoom="zoom"
                        :center="center"
                        style="height: 260px; width: 260px">
                        <l-tile-layer
                           :url="map_url"
                           :attribution="map_attribution"
                           :noWrap="noWrap"
                        />
                        <!--
                        <l-rectangle
                           :bounds="dataset_coverage_bound(datasetFieldValue(dataset,['SpatialExtent']),'map')"
                           :l-style="rectangle.style"
                        />
                        -->
                        <l-rectangle v-for="(bbox, index) in dataset_coverage_bboxes(datasetFieldValue(dataset,['SpatialExtent']))" :key="index"
                           :bounds="bbox"
                           :l-style="rectangle.style"
                        />
                        <l-circle-marker v-for="(bpoint, index) in dataset_coverage_bounding_points(datasetFieldValue(dataset,['SpatialExtent']))" :key="index"
                           :lat-lng="[bpoint[1],bpoint[0]]"
                           :radius="10"
                        />                        
                     </l-map>
                  </div>
               </div>
            </div>
            <div id="doc" v-if="dataset.showtab == 'doc'" :set="cloud_data_documentations = get_cloud_data_documentations(dataset['umm']['RelatedUrls'])">
               <div class="dataset-field fieldset resources">
                  <ul class="related-urls section" v-if="Object.keys(cloud_data_documentations).length > 0">
                     <li class="info-box" v-for="(docs, propertyName) in cloud_data_documentations" :key="propertyName">
                        <div class="label">{{propertyName|captialize_first_letter}}:</div>
                        <ul class="documentation section">
                           <li v-for="(doc, docIndex) in docs" :key="docIndex">
                              <a :href="doc['URL']" target="_blank">{{get_document_label(doc)}}</a>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </div>
               <!--
               <div class="dataset-field usage">
                  <component :is="dataset_url(dataset,'faceted-browse-documentation') ? 'a':'span'" :href="dataset_url(dataset,'faceted-browse-documentation') ||''" target="_blank"><label>Usage Examples >></label></component>
                  <ul class="related-urls">
                     <li v-for="(url, urlIndex) in cloud_data_usage_examples(dataset['umm']['RelatedUrls'])" :key="urlIndex">
                        <a :href="url['URL']" target="_blank">{{url['Subtype']}}</a>
                     </li>
                  </ul>
               </div>
               -->
            </div>
            <div id="citation" v-if="dataset.showtab == 'citation'">
               <div class="dataset-field citations" v-if="cloud_data_citation(dataset) != ''">
                  <div class="section" v-if="dataset['umm']['CollectionCitations'] != undefined">
                     <div class="label label-arrow-tag">Citations:</div>
                     <div class="field-content" v-html="cloud_data_citation(dataset)"></div>
                  </div>
                  <div class="section" v-if="dataset['umm']['PublicationReferences'] != undefined">
                     <div class="label label-arrow-tag">Journal Reference:</div>
                     <ul class="field-content" :set="references = cloud_data_journal_reference(dataset)">
                        <li v-for="(reference, referenceIndex) in references" :key="referenceIndex">{{reference}}</li>
                     </ul>
                  </div>
               </div>
            </div>
            <div id="access" v-if="dataset.showtab == 'access' && dataset['umm']['RelatedUrls'] != undefined" :set="dataaccess = cloud_data_services(dataset['umm']['RelatedUrls'])">
               <div class="dataset-field fieldset dataaccess">
                  <ul class="related-urls section" v-if="dataaccess['Direct Access'].length > 0" >
                     <li class="info-box">
                        <div class="label">Direct Access:</div>
                        <ul>
                           <li v-for="(url, directAccessUrlIndex) in dataaccess['Direct Access']" :key="directAccessUrlIndex">
                              <a :href="url['URL']" target="_blank">{{cloud_data_access_label(url)}}</a>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  <ul class="related-urls section" v-if="dataset['umm']['DirectDistributionInformation'] != undefined">
                     <li class="info-box">
                        <div class="label">Direct S3-Access:</div>
                        <ul>
                           <li>Available for access in-region with AWS Cloud
                              <ul class="aws-access">
                                 <li><span class="box__title">Region:</span>
                                    <ul>
                                       <li>{{dataset['umm']["DirectDistributionInformation"]["Region"]}}</li>
                                    </ul>
                                 </li>
                                 <li><span class="box__title">Bucket/Object Prefix: <a class="tool-tip"><i aria-hidden="true" class="fa fa-info-circle"></i><span class="tool-tip-text"><strong>Protected buckets</strong> contain the data files for a given collection. Protected simply means users must log in to Earthdata Login before gaining access to contents within that S3 Bucket. Please use the S3Credential endpoint to gain an Earthdata login token for use in S3 Access.<br/><br/><strong>Public buckets</strong>, in contrast, house metadata such as checksums, imagery, and metadata files and the like. A user can access public buckets and these types of files without logging in to Earthdata Login.<br/><br/><strong>Most of the time, you’ll want to access the protected bucket</strong></span> Information</a></span>
                                    <ul>
                                       <li v-for="(bucket, bucketIndex) in dataset['umm']['DirectDistributionInformation']['S3BucketAndObjectPrefixNames']" :key="bucketIndex">
                                          {{bucket}}
                                       </li>
                                    </ul>
                                 </li>
                                 <li><span class="box__title">AWS S3 Credentials:</span>
                                    <ul>
                                       <li><span class="aws_credential"><a :href="dataset['umm']['DirectDistributionInformation']['S3CredentialsAPIEndpoint']" target="_blank">Get AWS S3 Credentials</a></span><span>&nbsp;|&nbsp;</span>
                                       <span class="aws_doc"><a :href="dataset['umm']['DirectDistributionInformation']['S3CredentialsAPIDocumentationURL']" target="_blank">Documentation</a></span></li>
                                    </ul>
                                 </li>
                              </ul>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  <ul v-if="dataaccess['Tools and Services'].length > 0" class="related-urls section">
                     <li class="info-box"><div class="label">Tools and Services:</div>
                        <ul>
                           <li v-for="(url, toolServiceUrlIndex) in dataaccess['Tools and Services']" :key="toolServiceUrlIndex">
                              <a :href="url['URL']" target="_blank">{{cloud_data_access_label(url)}}</a>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  <ul v-if="dataaccess['Read Software'].length > 0" class="related-urls section">
                     <li class="info-box"><div class="label">Read Software:</div>
                        <ul>
                           <li v-for="(url, readSoftwareUrlIndex) in dataaccess['Read Software']" :key="readSoftwareUrlIndex">
                              <a :href="url['URL']" target="_blank">{{url['Description']}}</a>
                           </li>
                        </ul>
                     </li>
                  </ul>
               </div>
            </div>            
            <!--
            <div id="access" v-if="dataset.showtab == 'access'">
               <div class="dataset-field fieldset dataaccess">
                  <div class="related-urls" v-if="dataset['umm']['RelatedUrls'] != undefined" :set="dataaccess = cloud_data_services(dataset['umm']['RelatedUrls'])">
                  <ul v-if="dataaccess['Direct Access'].length > 0" class="section">
                     <li class="info-box"><div class="label">Direct Access:</div>
                        <ul>
                           <li v-for="(url, directAccessUrlIndex) in dataaccess['Direct Access']" :key="directAccessUrlIndex">
                              <a :href="url['URL']" target="_blank">{{cloud_data_access_label(url)}}</a>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  <div class="section" v-if="dataset['umm']['DirectDistributionInformation'] != undefined">
                     <div class="label">Direct S3-Access:</div>
                     <ul class="aws-access">
                        <li><span class="box__title">Region:</span>
                           <ul>
                              <li>{{dataset['umm']["DirectDistributionInformation"]["Region"]}}</li>
                           </ul>
                        </li>
                        <li><span class="box__title">Bucket/Object Prefix:</span>
                           <ul>
                              <li v-for="(bucket, bucketIndex) in dataset['umm']['DirectDistributionInformation']['S3BucketAndObjectPrefixNames']" :key="bucketIndex">
                                 {{bucket}}
                              </li>
                           </ul>
                        </li>
                        <li><span class="box__title">AWS S3 Credentials:</span>
                           <ul>
                              <li><span class="aws_credential"><a :href="dataset['umm']['DirectDistributionInformation']['S3CredentialsAPIEndpoint']" target="_blank">Get AWS S3 Credentials</a></span><span>&nbsp;|&nbsp;</span>
                              <span class="aws_doc"><a :href="dataset['umm']['DirectDistributionInformation']['S3CredentialsAPIDocumentationURL']" target="_blank">Documentation</a></span></li>
                           </ul>
                        </li>
                     </ul>
                  </div>
                  <ul v-if="dataaccess['Tools and Services'].length > 0" class="section">
                     <li class="info-box"><div class="label">Tools and Services:</div>
                        <ul>
                           <li v-for="(url, toolServiceUrlIndex) in dataaccess['Tools and Services']" :key="toolServiceUrlIndex">
                              <a :href="url['URL']" target="_blank">{{cloud_data_access_label(url)}}</a>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  <ul v-if="dataaccess['Read Software'].length > 0" class="section">
                     <li class="info-box"><div class="label">Read Software:</div>
                        <ul>
                           <li v-for="(url, readSoftwareUrlIndex) in dataaccess['Read Software']" :key="readSoftwareUrlIndex">
                              <a :href="url['URL']" target="_blank">{{url['Description']}}</a>
                           </li>
                        </ul>
                     </li>
                  </ul>
                  </div>
               </div>
            </div>
            -->
            <!--<div id="variables" v-if="dataset.showtab == 'variables' && dataset['meta']['associations'] != undefined && dataset['meta']['associations']['variables'] != undefined && dataset['umm']['variables'] != undefined">
               <table class="variables fixed-header">
                  <thead>
                     <tr>
                        <th>Label</th>
                        <th>Variable Name</th>
                     </tr>
                  </thead>
                  <tbody>
                     <tr v-for="(variable, umm_v_index) in dataset['umm']['variables']" :key="umm_v_index" :class="table_row_classes(umm_v_index)">
                        <td>{{variable['long_name']}}</td>
                        <td>{{variable['name']}}</td>
                     </tr>
                  </tbody>
               </table>
            </div>-->
         </div> <!-- /tabular-content /column-left -->
         <div class="column-right">
            <div class="dataset-field thumbnail">
               <img v-bind:src="thumbnail_source(dataset)" :alt="thumbnail_alt_text(dataset)" onerror="this.onerror=null;this.src='//podaac.jpl.nasa.gov/Podaac/thumbnails/image_not_available.jpg';">
            </div>
            <div class="dataset-field fieldset dataset-status">
               <div class="label">Status:</div>
               <div v-html="dataset['umm']['CollectionProgress']" />
            </div>
            <div class="dataset-field fieldset dataset-shortname" v-if="dataset['umm']['ShortName']">
               <div class="label">Short Name:</div>
               <div>{{dataset['umm']['ShortName']}}</div>
            </div>
            <div class="dataset-field fieldset concept-id">
               <div class="label">Collection Concept ID:</div>
               <div>{{dataset["meta"]["concept-id"]}}</div>
            </div>
            <div class="dataset-field fieldset spatial-converage">
               <div class="label">Spatial Coverage:</div>
               <div class="field-content coverage-text" v-for="(coverage_bound, key) in dataset_coverage_bound(datasetFieldValue(dataset,['SpatialExtent']))" :key="key">
                  <div class="coverage_field"><span class="label">N: </span>{{coverage_bound['N']}}&#176;</div>
                  <div class="coverage_field"><span class="label">S: </span>{{coverage_bound['S']}}&#176;</div>
                  <div class="coverage_field"><span class="label">W: </span>{{coverage_bound['W']}}&#176;</div>
                  <div class="coverage_field"><span class="label">E: </span>{{coverage_bound['E']}}&#176;</div>
               </div>
               <div class="field-content coverage-text" style="width:100%" v-for="(coverage_point, key) in dataset_coverage_bounding_points(datasetFieldValue(dataset,['SpatialExtent']))" :key="key">
                  <div class="coverage_field"><span class="label">Long: </span><br/>{{coverage_point[0]}}&#176;</div>
                  <div class="coverage_field"><span class="label">Lat: </span><br/>{{coverage_point[1]}}&#176;</div>
               </div>                              
            </div>            
            <template v-if="dataset['umm']['RelatedUrls'] != undefined">
            <div class="dataset-field fieldset dataaccess">
               <div class="label">Access:</div>
               <ul class="list eui-callout-box__list dataaccess">
                  <li v-for="(relatedUrl, relatedUrlIndex) in filter_data_access_urls(dataset['umm']['RelatedUrls'])" :key="relatedUrlIndex" class="data-access">
                     <a :href="relatedUrl.URL" :title="relatedUrl.URL" target="_blank">{{relatedUrl.Label}}</a>
                  </li>
               </ul>
            </div>
            </template>
            <div class="dataset-field fieldset services" v-if="dataset['meta']['associations'] != undefined">
               <div class="label">Capabilities:</div>
               <div class="icon-wrapper">
                  <div v-for="(item, key) in capabilities" :key="key"><span v-if="capability_filter_count(item, dataset).length > 0" :class="capabilities_service_classes(key.toLowerCase(), item, dataset['meta']['associations'])" :title="key" v-on:click="show_services_tools_modal({'dataset':dataset,'capability':key}, item, dataset['meta']['associations'])">{{key}}</span></div>
               </div>
            </div>
            <!--
            <div class="dataset-field fieldset services" v-if="dataset['meta']['associations'] != undefined && dataset['meta']['associations']['services'] != undefined">
               <label class="box__title">Capabilities</label>
               <div v-for="(service, index) in dataset['meta']['associations']['services']" :key="index" class="eui-badge--md service" v-html="get_service_text(service,'badge')">
               </div> -->
               <!--<template v-if="dataset['services'] != undefined && dataset['services']['items'] != null">
               <label class="box__title">Services</label>
               <div v-for="(service, serviceIndex) in dataset['services']['items']" :key="serviceIndex" class="eui-badge--md service" v-html="get_service_text(service['conceptId'],'badge')">
               </div>
               </template>-->
            <!--
            </div>
            -->
            <template v-if="dataset['umm']['RelatedUrls'] != undefined">
            <div class="dataset-field fieldset tutorials" v-if="dataset['umm']['tutorials'].length > 0">
               <div class="label">Data Recipes</div>
               <ul class="list eui-callout-box__list tutorials">
                  <li v-for="(relatedUrl, relatedUrlIndex) in dataset['umm']['tutorials']" :key="relatedUrlIndex">
                     <a :href="relatedUrl['URL']" target="_blank" :title="relatedUrl['Description']">{{truncateDescriptionText(relatedUrl['Description'],4)['default']}}{{truncateDescriptionText(relatedUrl['Description'],4)['clamp']}}</a>
                  </li>
               </ul>
            </div>
            </template>
         </div> <!-- /column-right -->
         </div> <!--/columns-wrapper-->
         </div><!--/data-->
         <div class="clearfix"></div>
      </div>
      <div class="more-link" v-if="filtered_item_count > load_item_count">
         <button class="eui-btn--blue" v-on:click="loadMore()">More</button>
      </div>
      <!--<datasets_modal v-show="isModalVisible" @close_modal="close_science_keyword_datasets_modal"></datasets_modal>
      <service_tools_modal v-show="serviceToolsModalVisible" @close_modal="close_service_tools_modal"></service_tools_modal>-->
   </div>
</template>

<script>
import Vue from "vue"
import {mapState,mapMutations} from "vuex";
import {LMap, LTileLayer, LRectangle, LCircleMarker} from "vue2-leaflet";
import datasets_processing from './mixins/datasets_processing';
import truncateDescription from './filters/truncateDescription.js';
import captialize_first_letter from './filters/captialize_first_letter.js';
//import datasets_modal from "@/components/datasets_modal";
//import service_tools_modal from "@/components/service_tools_modal";
import 'leaflet/dist/leaflet.css';
//import truncate from 'vue-truncate-collapsed';

export default {
   name: "DatasetList",
   mixins: [datasets_processing],
   filters: {
      truncateDescription,
      captialize_first_letter
   },
   components: {
      // datasets_modal,
      // service_tools_modal,
      LMap,
      LTileLayer,
      LRectangle,
      LCircleMarker
      //truncate
   },
   data() {
      return {
         // 'isModalVisible': false,
         // 'serviceToolsModalVisible':false,
         map_url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
         map_attribution: '&copy; <a href="https://openstreetmap.org/copyright">OpenStreetMap contributors</a>',
         zoom: 0,
         noWrap: true,
         center: [0, 0],
         rectangle: {
            style: {color: "#ff7800", weight: 1}
         },
      }
   },
   computed: {
      ...mapState([
         "basePath",
         'load_item_count',
         'filtered_item_count',
         'modal_science_keyword',
         'capabilities',
         'umm_s',
         'umm_var_api',
         'data_ready',
         'umm_g_api'
      ])
   },
   methods: {
      ...mapMutations([
         //"SET_MODAL_SCIENCE_KEYWORD",
         "SET_SCIENCE_KEYWORD_MODAL_DATA",
         "SET_SERVICES_TOOLS",
         "SET_MODAL_VISIBILITY"
      ]),
      cloud_data_citation: function(dataset) {
         let citation_text = '';
         //['umm']['CollectionCitations'], dataset['umm']['DOI']['DOI']
         if(dataset['umm']['CollectionCitations'] != undefined) {
            let citations = dataset['umm']['CollectionCitations'];
            Vue._.forEach(citations, function(citation) {
               if(citation['Creator'] != undefined) {
                  citation_text += citation['Creator'] + '. ';
               }
               if(citation['Title'] != undefined) {
                  citation_text += citation['Title'] + '. ';
               }
               if(citation['Version'] != undefined) {
                  citation_text += 'Ver. ' + citation['Version'] + '. ';
               }
            });
         }
         if(dataset['umm']['DOI'] != undefined) citation_text += 'PO.DAAC, CA, USA. accessed [YYYY-MM-DD]';
         if(dataset['umm']['DOI']['DOI'] != undefined) {
            citation_text += ' at <a href="https://doi.org/' + dataset['umm']['DOI']['DOI'] + '" target="_blank">' + dataset['umm']['DOI']['DOI'] + '</a>';
         }


         return citation_text;
      },
      cloud_data_journal_reference: function(dataset) {
         let journal_reference = [];
         if(dataset["umm"]["PublicationReferences"] != undefined) {
            dataset["umm"]["PublicationReferences"].forEach(function(reference) {
               if(reference["OtherReferenceDetails"] != undefined) {
                  journal_reference.push(reference["OtherReferenceDetails"]);
               }
               let reference_content = [];
               if(reference["Author"] != undefined) reference_content.push(reference['Author']);
               if(reference["PublicationDate"] != undefined) reference_content.push("(" + reference['PublicationDate'].split("-")[0] + ")");
               if(reference["Title"] != undefined) reference_content.push(reference['Title']);
               if(reference["Publisher"] != undefined) reference_content.push(reference['Publisher']);
               if(reference["Volume"] != undefined) reference_content.push(reference['Volume']);
               if(reference["Issue"] != undefined) reference_content.push(reference['Issue']);
               if(reference["DOI"] != undefined) reference_content.push(reference['DOI']['DOI']);
               if(reference_content.length > 0) journal_reference.push(reference_content.join(" "));
            });
         }
         return journal_reference;
      },
      get_cloud_data_documentations: function(urls) {
         var return_urls = {};
         if(urls != undefined) {
            urls.forEach(function(url) {
               if(url["URLContentType"] == "PublicationURL" && (url["Description"] == undefined || (url["Description"] != undefined && !url["Description"].includes('Thumbnail')))) {
                  if(return_urls[url["Subtype"]] == undefined) return_urls[url["Subtype"]] = [];
                  if(url["Description"] == undefined) url["Description"] = "";
                  return_urls[url["Subtype"]].push(url);
               }
            });
            // return_urls = urls.filter(function(url) {
            //    let to_return = false;
            //    if(url['Subtype'] == 'USER\'S GUIDE') {
            //       to_return = true;
            //    }
            //    return to_return;
            // });
         }
         return return_urls;
      },
      matching_processing_id: function(id) {
         //console.log(id);
         const re = /(1|2).?/;
         const result = id.match(re);
         //console.log(result);
         let match = false;
         //console.log(Array.isArray(result));
         if(Array.isArray(result)) {
            match = true;
         }
         return match;
      },
      cloud_data_services: function(urls) {
         let return_urls = {
            "Direct Access":[],
            "Tools and Services":[],
            "Read Software":[],
            "Data Access": []
         }

         if(urls != undefined) {
            // urls.forEach(function(url) {
            //    if(url["URLContentType"] == "DistributionURL" && ['USE SERVICE API','GET DATA'].includes(url["Type"])) {
            //       return_urls["Direct Access"].push(url);
            //    }
            // });
            //console.log(this.filter_data_access_urls(urls));
            return_urls["Direct Access"] = this.filter_data_access_urls(urls);

            // return_urls["Direct Access"] = urls.filter(function(url) {
            //    let to_return = false;
            //    if(url["URLContentType"] == "DistributionURL" && ['USE SERVICE API','GET DATA'].includes(url["Type"])) {
            //       to_return = true;
            //    }
            // });

            urls.forEach(function(url) {
               if(url["URLContentType"] == "DistributionURL" && !["DOWNLOAD SOFTWARE","GET DATA"].includes(url["Type"]) && !return_urls["Direct Access"].includes(url)) {
                  return_urls["Tools and Services"].push(url);
               }
            });

            // return_urls["Tools and Services"] = urls.filter(function(url) {
            //    let to_return = false;
            //    if(url["URLContentType"] == "DistributionURL" && !["DOWNLOAD SOFTWARE","GET DATA"].includes(url["Type"]) && !return_urls["Direct Access"].includes(url)) {
            //       to_return = true;
            //    }
            // });

            urls.forEach(function(url) {
               if(url["URLContentType"] == "DistributionURL" && url["Type"] == "DOWNLOAD SOFTWARE") {
                  return_urls["Read Software"].push(url);
               }
            });

            urls.forEach(function(url) {
               if(!return_urls["Direct Access"].includes(url) && !return_urls["Tools and Services"].includes(url) && !return_urls["Read Software"].includes(url)) {
                  return_urls["Data Access"].push(url);
               }
            });

            // return_urls["Read Software"] = urls.filter(function(url) {
            //    let to_return = false;
            //    if(url["URLContentType"] == "DistributionURL" && url["Type"] == "DOWNLOAD SOFTWARE") {
            //       to_return = true;
            //    }
            // });

            //return_urls["Direct Access"]

            // return_urls = urls.filter(function(url) {
            //    let to_return = false;
            //    if(url['Type'] == 'GOTO WEB TOOL') {
            //       console.log(url);
            //       to_return = true;
            //    }
            //    return to_return;
            // });
         }

         return return_urls;
      },
      cloud_data_access_label: function(url) {
         let description = (url['Label']) ? url['Label'] : url['Description'];
         if(url['Description'] == 'PO.DAAC Drive') {
            description.toUpperCase();
         } else if(url['URL'].includes('/ws/search/granule/')) {
            description = 'Web Service';
         } else if(url['URL'].includes('thredds.jpl.nasa.gov')) {
            description = 'THREDDS';
         } else if(url['Subtype'] == 'OPENDAP DATA') {
            description = 'OPENDAP DATA';
         }
         return description;
      },
      cloud_data_usage_examples: function(urls) {
         let return_urls = [];
         if(urls != undefined) {
            return_urls = urls.filter(function(url) {
               let to_return = false;
               if(url['Subtype'] == 'DATA RECIPE') {
                  to_return = true;
               }
               return to_return;
            })
         }

         return return_urls;
      },
      show_science_keyword_datasets_modal: function(keyword, measurements) {
         let self = this;
         let filtered_dataset_array = self.cloud_datasets.filter(function(dataset) {
            let science_keywords = self.dataset_unique_science_keywords(dataset['umm']['ScienceKeywords']), to_return = true;

            if(!science_keywords.includes(keyword)) {
               to_return = false;
            }

            return to_return;
         });

         if(filtered_dataset_array.length > 0) {
            //self.isModalVisible = true;
            self.SET_MODAL_VISIBILITY({'modal_name':'science_keyword_datasets','visibility':true});
            self.SET_SCIENCE_KEYWORD_MODAL_DATA({'datasets':filtered_dataset_array, 'measurements': measurements});
         }

         //this.SET_MODAL_SCIENCE_KEYWORD(science_keyword);
         //this.isModalVisible = true;
         //this.$forceUpdate();
      },
      // close_science_keyword_datasets_modal: function() {
      //    this.isModalVisible = false;
      // },
      // close_service_tools_modal: function() {
      //    this.serviceToolsModalVisible = false;
      // },
      progress_badge_icon: function(status) {
         let icon_class = ["eui-badge--md"];
         if(status.toLowerCase() == 'active' || status.toLowerCase() == 'complete') {
            icon_class.push("badge-green");
         }
         return icon_class;
      },
      thumbnail_alt_text: function(dataset) {
         let altext = "Thumbnail image of " + dataset["umm"]["EntryTitle"];
         let thumbnail_related_url = Vue._.filter(dataset["umm"]["RelatedUrls"], function(url) {
            if(url["Description"] != undefined && url["Description"].toLowerCase() == "thumbnail") return url;
         });
         if(thumbnail_related_url.length == 1) altext = "Placeholder " + altext;

         return altext;
      },
      thumbnail_source: function(dataset) {
         let thumbnail_path = "//podaac.jpl.nasa.gov/Podaac/thumbnails/image_not_available.jpg";
         let thumbnail_related_url = Vue._.filter(dataset["umm"]["RelatedUrls"], function(url) {
            if(url["Description"] != undefined && url["Type"] == "GET RELATED VISUALIZATION" && url["URL"].indexOf("thumbnail") >= 0) return url;
         });
         if(thumbnail_related_url.length == 1) thumbnail_path = thumbnail_related_url[0]["URL"];
         return thumbnail_path;
      },
      toggleTabContent: function(dataset, tab) {
         //this.showtab = tab;
         dataset.showtab = tab;
         this.$forceUpdate();
      },
      tabSelector: function(dataset, classes, tab) {
         if(dataset.showtab == undefined && tab == 'info') {
            classes.push('active');
         }
         if(dataset.showtab != undefined && dataset.showtab == tab) {
            classes.push('active');
         }
         return classes;
      },
      truncateDescriptionText: function(text, stop) {
         let text_array = text.split(" ");
         let processed_text = {
            'default': '',
            'more': ''
         };
         processed_text["default"] = text_array.slice(0, stop).join(' ');
         processed_text["more"] = (stop < text_array.length) ? text_array.slice(stop, text_array.length).join(" ") : '';
         processed_text["clamp"] = (stop < text_array.length) ? '...' : '';
// console.log(text);
// console.log(processed_text);
         return processed_text;
      },
      formatDateValue: function(datevalue) {
         let datestring = datevalue.split("T").shift();
         const date = new Date(datestring);
         return new Intl.DateTimeFormat('en', { year: 'numeric' }).format(date) + "-" + new Intl.DateTimeFormat('en', { month: 'short' }).format(date) + "-" + new Intl.DateTimeFormat('en', { day: '2-digit' }).format(date);
      },
      datasetProjectionData: function(dataText) {
         //console.log(dataText);
         let projectionData = {};
         let dataArray = dataText.split(",");
         //console.log(dataArray);
         dataArray.forEach(function(text) {
            let text_array = text.split(":");
            //console.log(text_array);
            if(text_array != undefined && Array.isArray(text_array)) {
               let projection_type = text_array[0];
               let projection_text = text_array[1];
               if (projection_text == undefined) {
                  projection_text = '';
               }
               projectionData[projection_type.trim()] = projection_text.trim();
            }            
         });
         //console.log(projectionData);
         return projectionData;
      },
      get_measurement_by_keyword: function(keyword, scienceKeywords) {
         let found_measurements = undefined;
         scienceKeywords.forEach(measurements => {
            Vue._.forOwn(measurements, function(val, key) {
               if(val == keyword) {
                  found_measurements = measurements;
               }
            });
         });

         return found_measurements;
      },
      load_coverage_content: function(dataset) {
         let self = this;
         if(dataset['ummg_loaded'] == undefined) {
            Vue.axios.get(self.umm_g_api + ".json?concept-id=" + dataset['meta']['concept-id'] + "&page_size=1&sort_key[]=-end_date").then((response)=> {               
               if(response['data']['feed']['entry'][0] != undefined && response['data']['feed']['entry'][0]['time_end'] != undefined && dataset['umm']['AdditionalAttributes'] != undefined) {                  
                  dataset['umm']['AdditionalAttributes'].push({
                     'Name':'latest_granule_ummg_end_time',
                     'Value':response['data']['feed']['entry'][0]['time_end']
                  });
                  self.$forceUpdate();
               }
               dataset['ummg_loaded'] = true;
            });
         }
      },
      // get_service_name: function(service_id) {
      //    const service = this.umm_s.items.filter(item => item.concept_id == service_id);
      //    console.log(service);
      //    let return_value = '';
      //    if(service != undefined)
      //       return_value = service[0].long_name;

      //    return return_value;
      // },
      // get_variable_by_key: function(variable_id, key) {
      //    const variable = this.umm_var.items.filter(item => item.concept_id == variable_id);
      //    let return_value = '';
      //    if(variable != undefined)
      //       return_value = variable[0][key];

      //    return return_value;
      // },
      retrieve_umm_var(dataset) {
         let self = this;
         let promises = [];
         if(dataset['umm']['variables'] == undefined) {
            dataset['umm']['variables'] = [];
            let umm_var_chunks = Vue._.chunk(dataset['meta']['associations']['variables'], 20);
            Vue._.forEach(umm_var_chunks, function(chunk) {
               let query_params = [], query_api = self.umm_var_api;
               Vue._.forEach(chunk, function(variable) {
                  query_params.push("concept_id[]=" + variable);
               });
               if(query_params.length > 0) {
                  query_api += "?page_size=" + chunk.length  + "&" + query_params.join("&");
                  promises.push(
                     Vue.axios.get(query_api).then(function(response) {
                        Vue._.forEach(response.data.items, function(item) {
                           dataset['umm']['variables'].push(item);
                        });
                     })
                  );
               }
            });

            Promise.all(promises).then(function() {
               //console.log(dataset['umm']['variables']);
               self.$forceUpdate();
            });
         }
      },
      dataset_measurements(science_keywords) {
         let measurements = '', measurement_keywords = [];
         Vue._.forEach(science_keywords, function(keywords) {
            if(measurement_keywords.length > 0 && measurements != '') measurements += '<br/>';
            measurement_keywords = [];
            if(keywords['Topic']) measurement_keywords.push(keywords['Topic']);
            if(keywords['Term']) measurement_keywords.push(keywords['Term']);
            if(keywords['VariableLevel1']) measurement_keywords.push(keywords['VariableLevel1']);
            measurements +=  measurement_keywords.join(" > ");
         });
         
         return measurements;
      },
      dataset_detail_more_button(dataset) {
         let button_text = "Show More";
         if(dataset["show_detail"]) {
            button_text = "Show Less";
         }
         return button_text;
      },
      toggle_description_wrapper_classes(dataset) {
         let classes = ['description-field','field-content'];
         if(!dataset["show_detail"]) {
            classes.push("hide-detail");
         }
         return classes;
      },
      toggle_dataset_detail(dataset) {
         dataset["show_detail"] = (!dataset["show_detail"]) ? true : false;
         this.$forceUpdate();
      },
      table_row_classes(row_index) {
         let classes = ['row']
         if(row_index % 2 == 0) {
            classes.push("odd");
         } else {
            classes.push("even");
         }
         return classes;
      },
      info_detail_wrapper_classes(show_detail) {
         let classes = ['info-detail-wrapper'];
         if(show_detail) {
            classes.push('show-detail')
         } else if(!show_detail && classes.indexOf('show-detail') > -1) {
            classes.splice(classes.indexOf('show-detail'), 1);
         }
         return classes;
      },
   }
}
</script>

<style>
.badge-green {
   background-color: #20ce6f;
}
</style>